import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';

var Like = function Like(props) {
  return React.createElement("svg", props, React.createElement("g", {
    fill: "#FFF",
    stroke: "#FFF",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M24.18 8.2h-4.253a.707.707 0 0 1-.621-.355.709.709 0 0 1-.01-.715l1.5-2.7a2.142 2.142 0 0 0 .094-1.908 2.142 2.142 0 0 0-1.458-1.236l-1.058-.264a.719.719 0 0 0-.71.216l-5.74 6.379A3.598 3.598 0 0 0 11 10.025v7.535c0 1.985 1.615 3.6 3.6 3.6h7.163a3.608 3.608 0 0 0 3.472-2.649l1.537-7.054A2.663 2.663 0 0 0 24.18 8.2M3 19.72c0 .795.645 1.44 1.44 1.44h4.32V6.76H2.44A1.44 1.44 0 0 0 1 8.2l2 11.52z"
  })));
};

Like.defaultProps = {
  width: "28",
  height: "22",
  viewBox: "0 0 28 22",
  xmlns: "http://www.w3.org/2000/svg"
};

var Dislike = function Dislike(props) {
  return React.createElement("svg", props, React.createElement("g", {
    fill: "#FFF",
    stroke: "#FFF",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M24.18 13.8h-4.253a.707.707 0 0 0-.621.355.709.709 0 0 0-.01.715l1.5 2.7c.33.592.363 1.287.094 1.908-.27.621-.8 1.072-1.458 1.236l-1.058.264a.719.719 0 0 1-.71-.216l-5.74-6.379A3.598 3.598 0 0 1 11 11.975V4.44c0-1.985 1.615-3.6 3.6-3.6h7.163a3.608 3.608 0 0 1 3.472 2.649l1.537 7.054A2.663 2.663 0 0 1 24.18 13.8M3 2.28C3 1.485 3.645.84 4.44.84h4.32v14.4H2.44A1.44 1.44 0 0 1 1 13.8L3 2.28z"
  })));
};

Dislike.defaultProps = {
  width: "28",
  height: "22",
  viewBox: "0 0 28 22",
  xmlns: "http://www.w3.org/2000/svg"
};
import { getHoursAndMinutes } from '../utils/formatDate';

var ChatMessages = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(ChatMessages, _React$PureComponent);

  function ChatMessages() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, ChatMessages);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ChatMessages)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      rating: -1,
      isRatingActive: true
    });

    _defineProperty(_assertThisInitialized(_this), "renderTime", function (timestamp) {
      return React.createElement("div", {
        className: "chatbot__time"
      }, timestamp ? getHoursAndMinutes(timestamp) : '');
    });

    _defineProperty(_assertThisInitialized(_this), "renderAnswerOption", function (item, key) {
      var submitQuestion = _this.props.submitQuestion;
      return React.createElement("div", {
        key: key,
        className: "chatbot__answerOption",
        onClick: function onClick() {
          return submitQuestion(item);
        }
      }, item.displayText);
    });

    _defineProperty(_assertThisInitialized(_this), "submitChatbotFeedback", function (rating) {
      return function () {
        var isRatingActive = _this.state.isRatingActive;
        if (!isRatingActive) return;
        var submitFeedback = _this.props.submitFeedback;
        submitFeedback(rating);

        _this.setState({
          rating: rating,
          isRatingActive: false
        });
      };
    });

    _defineProperty(_assertThisInitialized(_this), "renderQuestion", function (text, key, timestamp) {
      return React.createElement("div", {
        key: key,
        className: "chatbot__questionContainer chatbot__messageContainer"
      }, React.createElement("div", null, React.createElement("div", {
        className: "chatbot__questionMessage chatbot__message"
      }, text), _this.renderTime(timestamp)));
    });

    _defineProperty(_assertThisInitialized(_this), "renderAnswer", function (text, prompts, key, typing, timestamp, disabledOptions, feedback, customClass, icon) {
      var _this$props = _this.props,
          MessageIcon = _this$props.MessageIcon,
          AgentIcon = _this$props.AgentIcon,
          TypingIcon = _this$props.TypingIcon;
      return React.createElement("div", {
        key: key,
        className: "chatbot__answerContainer chatbot__messageContainer"
      }, icon && icon === 'agent' ? React.createElement(AgentIcon, null) : React.createElement(MessageIcon, null), typing ? React.createElement(TypingIcon, {
        className: "chatbot__typing"
      }) : React.createElement("div", null, React.createElement("div", {
        className: "chatbot__answerMessage chatbot__message ".concat(customClass || 'chatbot__defaultMsg')
      }, React.createElement("span", {
        dangerouslySetInnerHTML: {
          __html: text
        }
      }), feedback && _this.renderChatbotFeedback(), !disabledOptions && prompts && prompts.length > 0 && React.createElement("div", {
        className: "chatbot__answerOptionsContainer"
      }, prompts.map(function (item, anotherKey) {
        return _this.renderAnswerOption(item, anotherKey);
      }))), timestamp && _this.renderTime(timestamp)));
    });

    _defineProperty(_assertThisInitialized(_this), "renderMessages", function () {
      var _this$props2 = _this.props,
          conversationData = _this$props2.conversationData,
          msg = _this$props2.msg,
          enableTalkToAgent = _this$props2.enableTalkToAgent;
      var noAnswerPrompts = enableTalkToAgent ? [{
        displayText: msg('chatBot.talkWithAgent')
      }, {
        displayText: msg('chatBot.chatEnd.restart')
      }] : [{
        displayText: msg('chatBot.chatEnd.restart')
      }];
      var conversation = conversationData.map(function (item, key) {
        return item.get('type') === 'answer' ? _this.renderAnswer(item.get('id') === -1 ? msg('chatBot.noQuestionFound') : item.get('message'), item.get('id') === -1 ? noAnswerPrompts : item.get('prompts'), key, null, item.get('timestamp'), conversationData.size - 1 !== conversationData.indexOf(item), item.get('feedback'), item.get('customClass') || 'chatbot__defaultMsg', // QA identifier
        item.get('icon') || 'default') : _this.renderQuestion(item.get('message'), key, item.get('timestamp'));
      });
      return conversation;
    });

    return _this;
  }

  _createClass(ChatMessages, [{
    key: "renderChatbotFeedback",
    value: function renderChatbotFeedback() {
      var _this$state = this.state,
          rating = _this$state.rating,
          isRatingActive = _this$state.isRatingActive;
      return React.createElement("div", {
        className: "chatbot__rater ".concat(isRatingActive ? 'rater-active' : 'rater-inactive')
      }, React.createElement(Like, {
        className: "rater-like ".concat(rating === 1 ? 'rater-selected' : ''),
        onClick: this.submitChatbotFeedback(1)
      }), React.createElement(Dislike, {
        className: "rater-dislike ".concat(rating === 0 ? 'rater-selected' : ''),
        onClick: this.submitChatbotFeedback(0)
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var typing = this.props.typing;
      return React.createElement("div", null, this.renderMessages(), typing && this.renderAnswer(null, null, null, true));
    }
  }]);

  return ChatMessages;
}(React.PureComponent);

export { ChatMessages as default };